import axios from 'axios';
import Constants from '../constants';
import { ISurveyPrivacyPolicyEditModel } from '../models';

export async function copyPrivacyPolicy(surveyId: number): Promise<ISurveyPrivacyPolicyEditModel> {
	const res = await axios.post(`${Constants.API_PRIVACY_POLICY_URL.replace('{surveyId}', surveyId.toString())}/copy`);
	return res.data;
}

export async function clearPrivacyPolicy(surveyId: number): Promise<ISurveyPrivacyPolicyEditModel> {
	const res = await axios.post(`${Constants.API_PRIVACY_POLICY_URL.replace('{surveyId}', surveyId.toString())}/clear`);
	return res.data;
}

export async function UpdatePrivacyPolicy(
	surveyId: number,
	surveyPrivacyPolicyEditModel: ISurveyPrivacyPolicyEditModel,
): Promise<ISurveyPrivacyPolicyEditModel> {
	const res = await axios.put<ISurveyPrivacyPolicyEditModel>(
		`${Constants.API_PRIVACY_POLICY_URL.replace('{surveyId}', surveyId.toString())}/update`,
		surveyPrivacyPolicyEditModel,
	);
	return res.data;
}
